/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { cardTheme } from './styles'

const Card = ({ id, theme = 'default', className, onClick, children, innerRef, dataCy, ariaLabelledBy }) => (
  <div
    id={id}
    className={cx(styles.card, cardTheme(theme), className)}
    ref={innerRef}
    onClick={onClick}
    data-cy={dataCy}
    aria-labelledby={ariaLabelledBy}>
    {children}
  </div>
)

Card.propTypes = {
  id: PropTypes.string,
  theme: PropTypes.oneOf(['', 'default', 'light']),
  className: PropTypes.string,
  onClick: PropTypes.func,
  innerRef: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  dataCy: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
}

export default Card
